export const compareButtonStyles = {
  root:
    'text-fg-secondary hover:text-accent hover:bg-bg-subtle focus-visible:ring-accent relative inline-flex h-11 w-11 items-center justify-center rounded-md transition-colors duration-fast ease-token focus-visible:outline-none focus-visible:ring-2',
  icon: 'h-5 w-5',
  badge:
    'pointer-events-none absolute -right-0.5 -top-0.5 z-10 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-bold leading-none shadow-sm ring-2 ring-bg-canvas transition-colors duration-fast ease-token',
  badgeAvailable: 'bg-accent text-accent-fg',
  badgeFull: 'animate-compare-heartbeat bg-danger text-white',
} as const;
